import React, { Suspense, lazy, useState, useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import Loader from "../../../components/Loader/Loader";
import InfoCards from "../Comp/InfoCards";
import VenueList from "../VenueListComp/VenueList";
import VenueListDetails from "../VenueListComp/Details/VenueListDetails";
import JoinGame from "../MembersOnly/JoinGame/JoinGame";
import MembersOnlyGame from "../MembersOnly/JoinGame/MemberOnlyGame/MembersOnlyGame";
import MemberGameDetails from "../MembersOnly/JoinGame/MemberGameDetails/MemberGameDetails";
import BookingHistory from "../BookingHistory/BookingHistory";
import UpcomingBookings from "../BookingHistory/UpcomingBookings";
import PaymentHistory from "../PaymentHistory/PaymentHistory";
import CommunityBanner from "../Community/CommunityBanner";
import ScrollToTop from "../Comp/ScrollToTop";
import AboutMePhoneScreen from "../MyProfile/MobProfile/AboutMePhoneScreen";
const DashbordMainComponent = lazy(() => import("../Comp/DashboardMainComp"));
const OpportunitiesMain = lazy(() =>
  import("../Opportunities/OpportunitiesRoutes/OpportunitiesMain")
);
const MemberSponsorship = lazy(() =>
  import("../Sponsorship/MemberSponsorship")
);
const MyPortfolio = lazy(() => import("../Portfolio/MyPortfolio"));
const MySponsorship = lazy(() => import("../MySponsorship/MySponsorship"));
const MyProfile = lazy(() => import("../MyProfile/MyProfile"));
const KYCMain = lazy(() => import("../KYC/KYCMain"));
const Support = lazy(() => import("../Support/Support"));

function MemberRoutes({ showPopup, handleAddToHomeScreen }) {
  const location = useLocation();

  return (
    <Suspense fallback={""}>
      <ScrollToTop />
      <DashbordMainComponent
        pathname={location.pathname}
        showPopup={showPopup}
        handleAddToHomeScreen={handleAddToHomeScreen}
      >
        <Routes>
          <Route path="/booking/*" element={<OpportunitiesMain />} />
          {/* <Route path="/philanthropy" element={<MemberSponsorship />} /> */}
          <Route path="/myPortfolio" element={<MyPortfolio />} />
          <Route path="/myContribution" element={<MySponsorship />} />
          <Route path="/profile" element={<MyProfile />} />
          <Route path="/bookinghistory" element={<BookingHistory />} />
          <Route path="/aboutme" element={<AboutMePhoneScreen />} />
          <Route path="/upcomingbooking" element={<UpcomingBookings />} />
          <Route path="/paymenthistory" element={<PaymentHistory />} />
          <Route path="/club" element={<CommunityBanner />} />
          <Route path="/reserve/*" element={<VenueList />} />
          <Route path="/joingame/*" element={<JoinGame />} />
          <Route path="/membersOnlyGame" element={<MembersOnlyGame />} />
          <Route
            path="/joingameDetails/:booking_id"
            element={<MemberGameDetails />}
          />

          <Route
            path="/reserveDetails/:facilityId"
            element={<VenueListDetails />}
          />
          <Route path="/KYC" element={<KYCMain />} />
          <Route path="/explore" element={<InfoCards />} />
          <Route path="/support" element={<Support />} />
        </Routes>
      </DashbordMainComponent>
    </Suspense>
  );
}

export default MemberRoutes;
